export default __webpack_public_path__ + "static/v2-fb1581b034987baa5c75213a0d4dba0a.jpg";